import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "ic-badge-text",
	templateUrl: "./badge-text.component.html",
	styleUrls: ["./badge-text.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BadgeTextComponent {
	@Input()
	public type: "primary" | "secondary" | "danger" = "secondary";
	@Input() help: string;
	@Input() disabled: boolean | undefined;

	@Output() closeItem = new EventEmitter<void>();
}
